import { ACTIONS } from '../../enums/actions';
import { genericAction } from './genericAction';

export const getGlobalSettings = genericAction(ACTIONS.GET_GLOBAL_SETTINGS)
export const updateGlobalSettings = genericAction(ACTIONS.UPDATE_GLOBAL_SETTINGS)
